import { render, staticRenderFns } from "./CheckableTable.vue?vue&type=template&id=bda9e288&scoped=true&"
import script from "./CheckableTable.vue?vue&type=script&lang=ts&"
export * from "./CheckableTable.vue?vue&type=script&lang=ts&"
import style0 from "./CheckableTable.vue?vue&type=style&index=0&id=bda9e288&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bda9e288",
  null
  
)

export default component.exports